import AppLayout from '@/components/AppLayout';
import { useLanguage } from '@/contexts/LanguageContext';

export default function TermsConditions() {
  const { t } = useLanguage();
  
  return (
    <AppLayout>
      <div className="max-w-3xl mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">TERMINI E CONDIZIONI DI UTILIZZO – SERVICEGO</h1>
        <p className="text-sm text-gray-500 mb-8">Ultimo aggiornamento: Dicembre 2025</p>
        
        <div className="prose prose-sm max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Titolare della piattaforma</h2>
            <p>
              La piattaforma digitale denominata "ServiceGo" è di proprietà esclusiva ed è gestita da 
              <strong> I.F. Core Lab</strong>, di seguito denominata "Titolare" o "Gestore".
            </p>
            <p className="mt-3">
              Il Gestore esercita pieno ed esclusivo controllo sulla piattaforma, sulle sue funzionalità, 
              sui contenuti, sugli accessi e sulle condizioni di utilizzo, senza alcun obbligo di garantire 
              continuità, disponibilità o risultati.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Natura del servizio ed esclusione di responsabilità contrattuale</h2>
            <p>
              ServiceGo è una piattaforma tecnica che consente esclusivamente la pubblicazione, consultazione 
              e gestione di richieste e offerte di servizi tra utenti.
            </p>
            <p className="mt-3">
              Il Gestore <strong>non è in alcun modo parte</strong> dei rapporti contrattuali, economici o 
              professionali che si instaurano tra gli utenti della piattaforma.
            </p>
            <p className="mt-3">
              ServiceGo non agisce come intermediario, mandatario, agente, broker, rappresentante, datore di lavoro, 
              appaltatore o subappaltatore e non assume alcun obbligo di verifica, controllo o garanzia in merito 
              all'operato degli utenti.
            </p>
            <p className="mt-3">
              Ogni accordo, prestazione, pagamento, responsabilità civile, penale, amministrativa o fiscale 
              ricade <strong>esclusivamente sugli utenti coinvolti</strong>.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Accettazione integrale e vincolante</h2>
            <p>
              La registrazione, l'accesso o l'utilizzo della piattaforma comportano l'accettazione integrale, 
              incondizionata e vincolante dei presenti Termini e Condizioni e della Privacy Policy.
            </p>
            <p className="mt-3">
              L'utente dichiara di aver compreso che l'uso della piattaforma avviene sotto la propria esclusiva 
              responsabilità e rinuncia preventivamente a qualsiasi contestazione relativa al contenuto dei presenti Termini.
            </p>
            <p className="mt-3 font-semibold">
              In caso di mancata accettazione anche di una sola clausola, l'utente non è autorizzato a utilizzare ServiceGo.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Proprietà intellettuale</h2>
            <p>
              Tutti i diritti di proprietà intellettuale e industriale relativi a ServiceGo, inclusi ma non limitati 
              a codice sorgente, architettura software, design, grafica, loghi, testi, marchi, banche dati, 
              funzionalità e modello di business, sono di <strong>esclusiva proprietà di I.F. Core Lab</strong>.
            </p>
            <p className="mt-3">
              È severamente vietata qualsiasi forma di utilizzo non autorizzato, diretto o indiretto, totale o parziale, 
              inclusi copia, riproduzione, modifica, distribuzione, reverse engineering, decompilazione, scraping, 
              clonazione funzionale o utilizzo per piattaforme concorrenti.
            </p>
            <div className="bg-red-50 border-l-4 border-red-500 p-4 mt-4">
              <p className="text-red-700 font-semibold">
                Ogni violazione comporterà l'immediata azione legale del Titolare per la cessazione dell'illecito, 
                il risarcimento integrale del danno, la restituzione degli utili conseguiti e il rimborso delle 
                spese legali e peritali.
              </p>
            </div>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Obblighi e responsabilità degli utenti</h2>
            <p>
              Gli utenti sono unicamente responsabili delle informazioni fornite, dei contenuti pubblicati, 
              delle comunicazioni inviate e degli accordi conclusi tramite la piattaforma.
            </p>
            <p className="mt-3">
              Gli utenti garantiscono che i dati inseriti sono veritieri, aggiornati e conformi alla legge 
              e si impegnano a non utilizzare ServiceGo per finalità illecite, fraudolente o abusive.
            </p>
            <p className="mt-3">
              Il Gestore non risponde di dati falsi, incompleti, ingannevoli o illeciti inseriti dagli utenti.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Obblighi specifici dei professionisti e delle aziende</h2>
            <p>
              I professionisti e le aziende registrate dichiarano sotto la propria esclusiva responsabilità di essere 
              legalmente autorizzati a operare in Svizzera e di rispettare tutte le normative applicabili, incluse 
              quelle in materia di lavoro, sicurezza, assicurazioni, SUVA, OLL, diritto edilizio, fiscale e cantonale.
            </p>
            <p className="mt-3">
              Il Gestore non effettua verifiche preventive e non assume alcun obbligo di controllo o sorveglianza.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Esclusione e manleva totale di responsabilità</h2>
            <p>
              Nei limiti massimi consentiti dalla legge, I.F. Core Lab non potrà essere ritenuta responsabile, 
              a nessun titolo, per danni diretti o indiretti, patrimoniali o non patrimoniali, mancati guadagni, 
              perdite di dati, infortuni, ritardi, difetti di esecuzione, mancati pagamenti o controversie tra utenti.
            </p>
            <p className="mt-3 font-semibold">
              L'utente manleva integralmente il Gestore da qualsiasi pretesa, richiesta, danno o azione avanzata 
              da terzi in relazione all'utilizzo della piattaforma.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Abbonamenti, pagamenti e assenza di garanzie</h2>
            <p>
              Alcune funzionalità della piattaforma sono accessibili esclusivamente previo pagamento di un abbonamento.
            </p>
            <p className="mt-3">
              Gli abbonamenti sono a rinnovo automatico, non prevedono alcuna garanzia di risultati e non danno 
              diritto a rimborsi, indennizzi o compensazioni, anche in caso di mancato utilizzo del servizio.
            </p>
            <p className="mt-3">
              I pagamenti sono gestiti tramite fornitori terzi. Il Gestore non è responsabile per malfunzionamenti 
              imputabili a tali fornitori.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Modifica, sospensione e cessazione del servizio</h2>
            <p>
              Il Gestore si riserva il diritto, a propria esclusiva discrezione, di modificare, limitare, sospendere 
              o cessare, in tutto o in parte, la piattaforma o i servizi offerti, in qualsiasi momento, senza preavviso 
              e senza che ciò comporti alcun diritto a indennizzi o risarcimenti.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Sospensione e cancellazione degli account</h2>
            <p>
              Il Gestore può sospendere, limitare o cancellare un account in qualsiasi momento, anche senza preavviso 
              e senza obbligo di motivazione, in caso di violazione dei Termini, uso improprio della piattaforma, 
              sospetto di abuso o per tutela del sistema.
            </p>
            <p className="mt-3 font-semibold">
              La decisione del Gestore è definitiva e non contestabile.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Limitazione massima del risarcimento</h2>
            <p>
              Qualora, nonostante quanto sopra, fosse accertata una responsabilità del Gestore, l'importo massimo 
              risarcibile sarà in ogni caso limitato all'importo effettivamente versato dall'utente nei dodici mesi 
              precedenti l'evento dannoso, con esclusione di qualsiasi altro danno.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Protezione dei dati</h2>
            <p>
              Il trattamento dei dati personali avviene in conformità alla Legge federale svizzera sulla protezione 
              dei dati (LPD, revisione 2023) e al GDPR, ove applicabile, come descritto nella Privacy Policy.
            </p>
            <p className="mt-3">
              Il Gestore non è responsabile per violazioni derivanti da comportamenti degli utenti.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Modifiche ai Termini</h2>
            <p>
              Il Gestore si riserva il diritto di modificare in qualsiasi momento i presenti Termini e Condizioni. 
              L'uso continuato della piattaforma dopo le modifiche costituisce accettazione automatica delle stesse.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Clausola di separabilità</h2>
            <p>
              L'eventuale nullità o inefficacia di una o più clausole non pregiudica la validità delle restanti disposizioni.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Legge applicabile e foro competente</h2>
            <p>
              I presenti Termini e Condizioni sono regolati esclusivamente dal diritto svizzero.
            </p>
            <p className="mt-3 font-semibold">
              Per ogni controversia è competente in via esclusiva il Foro di Lugano, Svizzera.
            </p>
          </section>
          
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Contatti</h2>
            <p>
              <strong>I.F. Core Lab</strong><br />
              Email: <a href="mailto:support@servicego.ch" className="text-blue-600 hover:underline">support@servicego.ch</a>
            </p>
          </section>
        </div>
        
        <div className="mt-12 pt-6 border-t border-gray-200 text-center text-xs text-gray-500">
          © 2025 I.F. Core Lab - Tutti i diritti riservati
        </div>
      </div>
    </AppLayout>
  );
}
